// extracted by mini-css-extract-plugin
export default {"component-container":"ModuleSequencingSection_component-container__2n84t","coming-soon":"ModuleSequencingSection_coming-soon__-MiK3"};